// extracted by mini-css-extract-plugin
module.exports = {"container":"BottomBar-module__container--rTQFx","innerContainer":"BottomBar-module__innerContainer--26j_t"};